import * as React from "react";
import Svg, { Path } from "react-native-svg";

const UnTickStepIndicator = () => (
  <Svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M3 12c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9Z"
      fill="#fff"
      stroke="#E6E6E6"
      strokeWidth={2}
    />
  </Svg>
);

export default UnTickStepIndicator;
